import React from 'react'
import {FaClock} from 'react-icons/fa'
import Divider from '@components/V3/Divider'
import Text from '@components/V3/Text'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import dayjs from 'dayjs'
import {useTranslation} from 'next-i18next'

export default function DeliveredAt() {
  const status = useStatus()
  const {order} = useOrder()
  const {t} = useTranslation('tracking', {keyPrefix: 'deliveredAt'})
  if (['done', 'archived'].includes(status) === false) return null

  const completedAt = dayjs(order.completedAt)

  return (
    <div>
      <Divider full className="mb-4" />
      <div className="flex space-x-2 pb-2 items-center">
        <FaClock size={20} />
        <div className="flex-1">
          <Text type="body">
            {t('title', {
              date: completedAt.format('DD/MM/YYYY'),
              time: completedAt.format('HH:mm')
            })}
          </Text>
        </div>
      </div>
      <Divider full className="mb-4" />
    </div>
  )
}
